import { render, staticRenderFns } from "./HorizontalTextImageSectionModule.vue?vue&type=template&id=89f7109a&"
import script from "./HorizontalTextImageSectionModule.vue?vue&type=script&lang=js&"
export * from "./HorizontalTextImageSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports